// Server-only access to the OTel trace API. The typeof-window guard lets
// bundlers drop @opentelemetry/api from client bundles instead of shipping
// dead code; on the server, @vercel/otel (dash0.server.config.ts) owns the
// tracer provider on the Node runtime and registers an
// AsyncLocalStorage context manager, so trace.getActiveSpan() returns the
// active request span without coupling callers to the tracing setup.
export const trace =
  typeof window === 'undefined'
    ? (require('@opentelemetry/api') as typeof import('@opentelemetry/api')).trace
    : undefined;
